import React, { useState, useEffect } from 'react';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button,
  CardContent, Divider, InputLabel, CardHeader, MenuItem, Switch,
  Typography, DialogContentText, CircularProgress
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import tokenService from '../../../utils/tokenDecoder';
import { useNavigate, useParams } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { LoadingComponent } from '../../../utils/newLoader';
import PageHeader from 'src/views/Common/PageHeader';
import tokenDecoder from '../../../utils/tokenDecoder';
import { useAlert } from 'react-alert';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  cardContent: {
    border: `2px solid #e8eaf6`
  }
}));

const screenCode = 'ITEMWAREHOUSE';
export default function AddEditWarehouse() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [title, setTitle] = useState('Add Warehouse');
  const [groups, setGroups] = useState();
  const [isUpdate, setIsUpdate] = useState(false);
  const [factories, setFactories] = useState();
  const [IsActiveValue, setIsActiveValue] = useState(true);
  const [whID, setwhID] = useState('');
  const [ArrayField, setArrayField] = useState([]);
  const [addConfirmation, setAddConfirmation] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [backConfirmation, setBackConfirmation] = useState(false);
  const [deleteYesDisable, setDeleteYesDisable] = useState(false);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isRegionFilterEnabled: false
  });
  const [warehouse, setWarehouse] = useState({
    groupID: 0,
    factoryID: 0,
    warehouseCode: '',
    warehouseName: '',
    isActive: true
  });
  const alert = useAlert();
  const { warehouseID } = useParams();

  let decryptedID = 0;

  const handleClick = () => {

    if (!isUpdate) {
      sessionStorage.removeItem('warehouse-listing-page-search-parameters-id');
    }
    navigate('/app/Warehouse/listing');
  };

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropDown());
  }, [warehouse.groupID]);

  useEffect(() => {
    decryptedID = atob(warehouseID.toString());
    setwhID(decryptedID);
    if (decryptedID != 0) {
      trackPromise(GetwarehouseDetailsBywarehouseID(decryptedID));
    }
  }, []);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'ADDEDITITEMWAREHOUSE'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });


    setWarehouse({
      ...warehouse,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  function onIsActiveChange() {
    setIsActiveValue(!IsActiveValue);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getFactoriesForDropDown() {
    const factoryList = await services.getFactoryByGroupID(warehouse.groupID);
    setFactories(factoryList);
  }

  async function GetwarehouseDetailsBywarehouseID(warehouseID) {
    let response = await services.GetwarehouseDetailsBywarehouseID(warehouseID);
    setTitle('Edit Warehouse');
    setWarehouse({
      ...warehouse,
      groupID: response.groupID,
      factoryID: response.factoryID,
      warehouseCode: response.warehouseCode,
      warehouseName: response.warehouseName
    });
    setIsActiveValue(response.isActive);
    setIsUpdate(true);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  const generateFactoryDropDownMenu = (data) => {
    return data ? data.map(({ id, name }) => (
      <MenuItem key={id} value={id}>{name}</MenuItem>
    )) : [];
  };

  function handleChangeForm(e) {
    const target = e.target;
    const value = target.value;
    setWarehouse({
      ...warehouse,
      [e.target.name]: value
    });
  }

  function handleAddOpen() {
    setAddConfirmation(true)
  }

  function handleAddOpen() {
    setAddConfirmation(true)
  }

  function handleAdd() {
    setAddConfirmation(false)
  }

  const handleAddOnChange = () => {
    if (isProcessing) return;
    setIsProcessing(true);
    SaveWarehouseDetails()
    setAddConfirmation(false);
    setTimeout(() => {
      setIsProcessing(false);
    }, 1000);
  }

  function handleDelete() {
    setDeleteConfirmation(false)
  }

  const handleDeleteOpen = (row, index) => {
    setSelectedRow({ row, index });
    setDeleteConfirmation(true);
  };

  function handleConfirmBackOne() {
    if (ArrayField.length != 0) {
      handleConfirmBackOpen();
    } else {
      if (!isUpdate) {
        sessionStorage.removeItem('warehouse-listing-page-search-parameters-id');
      }
      handleClick();
    }
  }

  function handleConfirmBack() {
    setBackConfirmation(false);
    if (!isUpdate) {
      sessionStorage.removeItem('warehouse-listing-page-search-parameters-id');
    }
    navigate('/app/warehouse/listing');
  }

  const handleConfirmBackTwo = () => {
    setBackConfirmation(false);
    if (!isUpdate) {
      sessionStorage.removeItem('warehouse-listing-page-search-parameters-id');
    }

    navigate('/app/warehouse/listing');
  }

  const handleDialogClose = () => {
    setBackConfirmation(false);
  };

  function handleConfirmBackOpen() {
    setBackConfirmation(true);
  }

  const handleDeleteOnChange = () => {
    setDeleteYesDisable(true);
    setTimeout(() => {
      setDeleteYesDisable(false);
    }, 3000);

    if (selectedRow !== null) {
      const updatedArray = [...ArrayField];
      updatedArray.splice(selectedRow.index, 1);
      setArrayField(updatedArray);
    }
    setDeleteConfirmation(false);
  };

  async function onClearData() {
    setWarehouse({
      ...warehouse,
      warehouseCode: '',
      warehouseName: '',
      isActive: true
    });
  }

  async function SaveWarehouseDetails(values) {
    if (isUpdate == true) {
      let updateModel = {
        warehouseID: parseInt(whID),
        createdBy: parseInt(tokenService.getUserIDFromToken()),
        groupID: parseInt(values.groupID),
        factoryID: parseInt(values.factoryID),
        warehouseCode: values.warehouseCode,
        warehouseName: values.warehouseName,
        modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()) || 0,
        isActive: IsActiveValue
      };
      let response = await services.UpdateWarehouse(updateModel);
      if (response.statusCode == 'Success') {
        alert.success(response.message);
        navigate('/app/Warehouse/listing');
      } else {
        alert.error(response.message);
      }
    } else {
      let saveModel = {
        groupID: parseInt(values.groupID) || 0,
        factoryID: parseInt(values.factoryID),
        warehouseName: values.warehouseName || '',
        warehouseCode: values.warehouseCode || '',
        isActive: values.isActive,
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()) || 0
      };
      let response = await services.SaveWarehouseDetails(saveModel);
      if (response.statusCode == 'Success') {
        alert.success("Warehouse details Saved successfully");
        navigate('/app/Warehouse/listing');
      } else {
        alert.error(response.message);
      }
    }
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader onClick={handleConfirmBackOne} />
        </Grid>
      </Grid>
    );
  }

  return (
    <Page className={classes.root} title={title}>
      <Container maxWidth={false}>
        <LoadingComponent />
        <Formik
          initialValues={{
            groupID: warehouse.groupID,
            factoryID: warehouse.factoryID,
            warehouseCode: warehouse.warehouseCode,
            warehouseName: warehouse.warehouseName,
            isActive: warehouse.isActive
          }}
          validationSchema={Yup.object().shape({
            factoryID: Yup.number().when('entityTypeID', {
              is: (val) => val == 3,
              then: Yup.number()
                .required('Estate is required')
                .min(1, 'Select an Estate'),
              otherwise: Yup.number().notRequired(),
            }),
            warehouseCode: Yup.string()
              .max(255)
              .required('Warehouse Code is required')
              .matches(/^\S.*\S$|^\S$/, 'Spaces are not allowed at start or end'),
            warehouseName: Yup.string()
              .required('Warehouse Name is required')
              .matches(/^\S.*\S$|^\S$/, 'Spaces are not allowed at start or end'),
          })}
          onSubmit={value => SaveWarehouseDetails(value)}
          enableReinitialize
        >
          {({ errors, handleBlur, handleSubmit, touched }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={3}>
                <Card className={classes.cardContent}>
                  <CardHeader title={cardTitle(title)} />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent style={{ marginBottom: "2rem" }}>
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField
                            select
                            error={Boolean(touched.groupID && errors.groupID)}
                            fullWidth
                            helperText={touched.groupID && errors.groupID}
                            size="small"
                            name="groupID"
                            onBlur={handleBlur}
                            onChange={e => handleChangeForm(e)}
                            value={warehouse.groupID}
                            variant="outlined"
                            id="groupID"
                            InputProps={{
                              disabled:
                                isUpdate || !permissionList.isGroupFilterEnabled
                                  ? true
                                  : false
                            }}
                          >
                            <MenuItem value="0">
                              --Select Group--
                            </MenuItem>
                            {generateDropDownMenu(groups)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">
                            Factory *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            fullWidth
                            helperText={touched.factoryID && errors.factoryID}
                            size='small'
                            name="factoryID"
                            onChange={(e) => {
                              handleChangeForm(e)
                            }}
                            value={warehouse.factoryID}
                            variant="outlined"
                            id="factoryID"
                            InputProps={{
                              disabled:
                                isUpdate || !permissionList.isFactoryFilterEnabled
                                  ? true
                                  : false
                            }}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="warehouseCode">
                            Warehouse Code *
                          </InputLabel>
                          <TextField
                            error={Boolean(
                              touched.warehouseCode && errors.warehouseCode
                            )}
                            fullWidth
                            helperText={
                              touched.warehouseCode && errors.warehouseCode
                            }
                            size="small"
                            name="warehouseCode"
                            onBlur={handleBlur}
                            onChange={e => handleChangeForm(e)}
                            value={warehouse.warehouseCode}
                            variant="outlined"
                            InputProps={{
                              disabled:
                                isUpdate ? true : false
                            }}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="warehouseName">
                            Warehouse Name *
                          </InputLabel>
                          <TextField
                            error={Boolean(
                              touched.warehouseName && errors.warehouseName
                            )}
                            fullWidth
                            helperText={
                              touched.warehouseName && errors.warehouseName
                            }
                            size="small"
                            name="warehouseName"
                            onBlur={handleBlur}
                            onChange={e => handleChangeForm(e)}
                            value={warehouse.warehouseName}
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                    <Grid container spacing={0}>
                      <Grid item md={1} xs={12} style={{ marginLeft: '1rem' }}>
                        <InputLabel id="isActive">Active</InputLabel>
                        <Switch
                          error={Boolean(touched.isActive && errors.isActive)}
                          helperText={touched.isActive && errors.isActive}
                          checked={IsActiveValue}
                          onBlur={handleBlur}
                          onChange={onIsActiveChange}
                          name="isActive"
                          size="medium"
                        />
                      </Grid>
                    </Grid>
                    <Divider />
                    <Box display="flex" justifyContent="flex-end" p={2}>
                      <Button
                        color="primary"
                        type="submit"
                        variant="contained"
                        size="small"
                      >
                        {isUpdate ? "Update" : "Save"}
                      </Button>
                    </Box>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
      </Container>
      <Dialog open={backConfirmation} onClose={handleDialogClose}>
        <DialogTitle id="alert-dialog-slide-title">
          <Typography
            color="textSecondary"
            gutterBottom
            variant="h3">
            <Box textAlign="center">
              Confirmation
            </Box>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Typography variant="h5">Are you sure do you want to go back?</Typography>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleDialogClose} color="primary" autoFocus>
            No
          </Button>
          <Button onClick={handleConfirmBack} color="primary">
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteConfirmation}>
        <DialogTitle id="alert-dialog-delete">
          <Typography
            color="textSecondary"
            gutterBottom
            variant="h3">
            <Box textAlign="center">
              Confirmation
            </Box>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-delete-description">
            <Typography variant="h5">Are you sure do you want to delete this data?</Typography>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteOnChange} color="primary" disabled={deleteYesDisable}
          >
            {deleteYesDisable ? <CircularProgress size="1.3rem" /> : 'Yes'}
          </Button>
          <Button
            onClick={handleDelete} color="primary" autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={addConfirmation}>
        <DialogTitle id="alert-dialog-add">
          <Typography
            color="textSecondary"
            gutterBottom
            variant="h3">
            <Box textAlign="center">
              Confirmation
            </Box>
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-add-description">
            <Typography variant="h5">
              {isUpdate
                ? "Are you sure do you want to Update this Record?"
                : "Are you sure do you want to Save this Record?"}
            </Typography>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <br />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleAdd} color="primary" autoFocus>
            No
          </Button>
          <Button onClick={handleAddOnChange} color="primary"
            disabled={isProcessing}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}
